import React from "react" ;
import { ReactNode } from "react" ;
import ObservableState from "../utils/ObservableState" ;
import * as ui from "../native" ;
import ObservableComponent from "./ObservableComponent" ;
import BaseUIProps , { copyBaseUIProps } from "../native/ui/BaseUIProps" ;
import D3EDisposable from "../rocket/D3EDisposable" ;
import TextValueField from "./TextValueField" ;
import Popup from "./Popup" ;
import MaterialIcons from "../icons/MaterialIcons" ;
import User from "../models/User" ;
import IconButton from "./IconButton" ;
import TextValueWithButton from "./TextValueWithButton" ;
import Query from "../classes/Query" ;
import MessageDispatch from "../rocket/MessageDispatch" ;
import PainsCardView from "./PainsCardView" ;
import HotList from "../models/HotList" ;
import RemainderCreatorView from "./RemainderCreatorView" ;
import LeadRemainder from "../models/LeadRemainder" ;
import Browser from "../classes/Browser" ;
import ScrollView2 from "./ScrollView2" ;
import Lead from "../models/Lead" ;
import TextView from "./TextView" ;
import NeedsCardView from "./NeedsCardView" ;
import { UsageConstants } from "../rocket/D3ETemplate" ;
import { BuildContext } from "../classes/BuildContext" ;


  export  interface  NeedsAndPainsCardViewProps extends  BaseUIProps {   key?: string ;
   lead: Lead ;
   user: User ;
 }

   class  _NeedsAndPainsCardViewState extends  ObservableComponent<NeedsAndPainsCardViewProps> {   static defaultProps = { lead:null, user:null } ;
   columnScrollController: ui.ScrollController = new ui.ScrollController() ;
   remainder: LeadRemainder = null ;
   remainderPopupPopup: Popup ;
   static contextType = BuildContext ;
   context: React.ContextType<typeof BuildContext> ;
  public leadDisposable: D3EDisposable ;
 public constructor ( props : NeedsAndPainsCardViewProps ) {
 super(props);

this.initState();
 }
  public get lead (  ) : Lead {
 return this.props.lead ; 
 }
  public get user (  ) : User {
 return this.props.user ; 
 }
  public initState (  ) {
 super.initState();

this.runFetchDataQueryForLead();

this.leadDisposable=MessageDispatch.get().syncObject(this.props.lead,UsageConstants.QUERY_GETLEADBYID_NEEDSANDPAINSCARDVIEW_LEAD_FETCHDATA);

this.initListeners();

this.enableBuild=true;
 }
  public initListeners (  ) : void {
 this.updateSyncProperty('lead',this.props.lead);

this.updateSyncProperty('user',this.props.user);

this.on([ 'lead', 'lead.designation', 'lead.hotLists', 'lead.hotLists.imageUrls', 'lead.isScrapedData', 'lead.linkedInProfile', 'lead.reminders', 'lead.reminders.description', 'lead.reminders.remainderDate' ],this.rebuild);
 }
  public componentDidUpdate ( prevProps : NeedsAndPainsCardViewProps ) : void {
 super.componentDidUpdate(prevProps);

if ( prevProps.lead !== this.props.lead ) {
 this.updateObservable('lead',prevProps.lead,this.props.lead);

this.runFetchDataQueryForLead();

this.fire('lead',this);
 }

if ( prevProps.user !== this.props.user ) {
 this.updateObservable('user',prevProps.user,this.props.user);

this.fire('user',this);
 }
 }
  public runFetchDataQueryForLead  =  (  ) : void  =>  {
 if ( this.lead == null ) {
 return ; 
 }

Query.get().getLeadById(UsageConstants.QUERY_GETLEADBYID_NEEDSANDPAINSCARDVIEW_LEAD_FETCHDATA,this.lead.id);
 }
  public setRemainder ( val : LeadRemainder ) : void {
 let isValChanged :boolean=this.remainder !== val;

if ( !isValChanged ) {
 return ; 
 }

this.updateObservable('remainder',this.remainder,val);

this.remainder=val;

this.fire('remainder',this);
 }
  public render (  ) : ReactNode {
 let cStyle=this.context.theme;

return ui.Column({ crossAxisAlignment:ui.CrossAxisAlignment.start, mainAxisAlignment:ui.MainAxisAlignment.start, children:[ ui.Column({ children:[ ui.Row({ mainAxisAlignment:ui.MainAxisAlignment.spaceBetween, children:[ TextView({ data:'Remainders', style:new ui.TextStyle({fontSize:cStyle.tTextViewHeadlineFourFontSizeOn,fontWeight:cStyle.tTextViewHeadlineFourFontWeightOn}), className:'HeadlineFour x6506', key:'0' }), ui.Container({ className:'xe90 hc h', key:'1' }), IconButton({ icon:MaterialIcons.add, size:20, color:cStyle.c10, onPressed:(  ) => {
 this.onAddRemainderButtonPressed();
 }
, key:'2' }) ], className:'x5aa h', key:'0' }), (this.lead.reminders).expand(( remainder ) => [ TextValueField({ label:remainder?.remainderDate.toString() ?? '', value:remainder?.description ?? '', className:'x3020 h', key:remainder?.ident }) ]) ], className:'xd4f h', key:'0' }), ((this.lead.isScrapedData) ? TextView({ data:'Jobs & HotList', style:new ui.TextStyle({fontSize:cStyle.tTextViewHeadlineFourFontSizeOn,fontWeight:cStyle.tTextViewHeadlineFourFontWeightOn}), className:'HeadlineFour x726' }) : [  ]), ((this.lead.isScrapedData) ? TextValueField({ value:this.lead.designation?.isEmpty ? '---' : this.lead.designation, label:'Designation', className:'x6ce h' }) : [  ]), ((this.lead.isScrapedData) ? TextValueWithButton({ label:'Linkedin Profile', value:this.lead?.linkedInProfile ?? '', onOpen:(  ) => {
 this.onLinkedinLabelButtonHandler();
 }
, className:'x178 h' }) : [  ]), ((this.lead.isScrapedData) ? ui.Column({ children:[ (this.lead.hotLists).expand(( item ) => [ TextValueWithButton({ label:'HotList', value:item?.imageUrls ?? '', onOpen:(  ) => {
 this.onHotListButtonHandler(item);
 }
, className:'x8dc h', key:item?.ident }) ]) ], className:'x5ca h' }) : [  ]), TextView({ data:'Needs & Pains', style:new ui.TextStyle({fontSize:cStyle.tTextViewHeadlineFourFontSizeOn,fontWeight:cStyle.tTextViewHeadlineFourFontWeightOn}), className:'HeadlineFour x4379', key:'5' }), ScrollView2({child:ui.Column({ children:[ NeedsCardView({ lead:this.lead, className:'x248 h', key:'0' }), ui.Container({ margin:ui.EdgeInsets.fromLTRB(0.0,10.0,0.0,0.0,new Map()), child:PainsCardView({ lead:this.lead }), key:'1', className:'xe06 h' }) ], key:'6' }),scrollDirection:ui.Axis.vertical,className:'xa1c vc h v',controller:this.columnScrollController}) ], className:ui.join('BaseViewStyle NeedsAndPainsCardView xda18 vc h v ' , this.props.className ?? ''), ...copyBaseUIProps(this.props,) }) ; 
 }
  public onHotListButtonHandler  =  ( item : HotList ) : void  =>  {
 if ( item.imageUrls !== null && item.imageUrls.isNotEmpty ) {
 Browser.open(item.imageUrls);
 }
 }
  public onLinkedinLabelButtonHandler  =  (  ) : void  =>  {
 Browser.open(this.lead.linkedInProfile);
 }
  public onAddRemainderButtonPressed  =  (  ) : void  =>  {
 this.setRemainder(new LeadRemainder({ lead:this.lead, createdBy:this.user }));

this.showRemainderPopup();
 }
  public dispose (  ) : void {
 this.leadDisposable?.dispose();

this.remainderPopupPopup?.dispose();

super.dispose();
 }
  public showRemainderPopup ( d3eParams ? : Partial<{autoClose: boolean, model: boolean, float: boolean, takeFocus: boolean}> ) : void {
 let autoClose=d3eParams?.autoClose;

let model=d3eParams?.model;

let float=d3eParams?.float;

let takeFocus=d3eParams?.takeFocus;

this.remainderPopupPopup ?. dispose();

this.remainderPopupPopup=new Popup({autoClose:autoClose,model:model,float:float,takeFocus:takeFocus,position:ui.PopUpPosition.Center,child:ui.Container({ width:500, child:RemainderCreatorView({ leadRemainder:this.remainder }), className:'xac7 hc vc' })});

this.remainderPopupPopup.showPopup(this.context);
 }
  public hideRemainderPopup (  ) : void {
 this.remainderPopupPopup ?. dispose();
 }
 }
export default function NeedsAndPainsCardView ( props : NeedsAndPainsCardViewProps ) {
 return React.createElement(_NeedsAndPainsCardViewState,{ ..._NeedsAndPainsCardViewState.defaultProps, ...props }) ; 
 }
